"use strict";
const $09e991522ca7e64e$var$gameField = document.querySelector(".game-field");
const $09e991522ca7e64e$var$scoreField = document.querySelector(".game-score");
const $09e991522ca7e64e$var$startMessage = document.querySelector(".message-start");
const $09e991522ca7e64e$var$loseMessage = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$winMessage = document.querySelector(".message-win");
const $09e991522ca7e64e$var$button = document.querySelector(".button");
const $09e991522ca7e64e$var$initialState = Array.from({
    length: $09e991522ca7e64e$var$gameField.tBodies[0].rows.length
}, ()=>Array($09e991522ca7e64e$var$gameField.tBodies[0].rows[0].cells.length).fill(0));
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    static STATUSES = {
        idle: "idle",
        playing: "playing",
        win: "win",
        lose: "lose"
    };
    constructor(initialState = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ], gameBoard, scoreField){
        this.initialState = initialState;
        this.state = initialState.map((row)=>[
                ...row
            ]);
        this.status = $a5fd07fa01589658$var$Game.STATUSES.idle;
        this.score = 0;
        this.gameBoard = gameBoard;
        this.scoreField = scoreField;
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.state;
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.status = $a5fd07fa01589658$var$Game.STATUSES.playing;
        this.#addCell();
        this.#addCell();
    }
    restart() {
        this.state = this.initialState.map((row)=>[
                ...row
            ]);
        this.status = $a5fd07fa01589658$var$Game.STATUSES.idle;
        this.score = 0;
    }
    moveLeft() {
        if (this.status !== $a5fd07fa01589658$var$Game.STATUSES.playing) return;
        let canMoveLeftInGroup = false;
        this.state = this.state.map((row)=>{
            if (!this.#canMoveInGroup(row)) return row;
            canMoveLeftInGroup = true;
            return this.#moveCellsInGroup(row);
        });
        if (canMoveLeftInGroup) this.#addCell();
        this.#setStatus();
    }
    moveRight() {
        if (this.status !== $a5fd07fa01589658$var$Game.STATUSES.playing) return;
        let canMoveRightInGroup = false;
        this.state = this.state.map((row)=>{
            const rowReversed = [
                ...row
            ].reverse();
            if (!this.#canMoveInGroup(rowReversed)) return row;
            canMoveRightInGroup = true;
            return this.#moveCellsInGroup(rowReversed).reverse();
        });
        if (canMoveRightInGroup) this.#addCell();
        this.#setStatus();
    }
    moveUp() {
        if (this.status !== $a5fd07fa01589658$var$Game.STATUSES.playing) return;
        let canMoveUpInGroup = false;
        const cellsGroupByColumns = this.#transpose(this.state);
        const updatedCellsGroupByColumns = cellsGroupByColumns.map((row)=>{
            if (!this.#canMoveInGroup(row)) return row;
            canMoveUpInGroup = true;
            return this.#moveCellsInGroup(row);
        });
        this.state = this.#transpose(updatedCellsGroupByColumns);
        if (canMoveUpInGroup) this.#addCell();
        this.#setStatus();
    }
    moveDown() {
        if (this.status !== $a5fd07fa01589658$var$Game.STATUSES.playing) return;
        let canMoveDownInGroup = false;
        const cellsGroupByColumns = this.#transpose(this.state);
        const updatedCellsGroupByColumns = cellsGroupByColumns.map((row)=>{
            const reversedRow = [
                ...row
            ].reverse();
            if (!this.#canMoveInGroup(reversedRow)) return row;
            canMoveDownInGroup = true;
            return this.#moveCellsInGroup(reversedRow).reverse();
        });
        this.state = this.#transpose(updatedCellsGroupByColumns);
        if (canMoveDownInGroup) this.#addCell();
        this.#setStatus();
    }
    updateGameBoard() {
        const regex = /field-cell--\d+/;
        const currState = this.getState();
        this.scoreField.innerText = this.getScore();
        for(let i = 0; i < currState.length; i++)for(let j = 0; j < currState.length; j++){
            if (currState[i][j] !== 0) {
                this.gameBoard.rows[i].cells[j].className = `field-cell field-cell--${currState[i][j]}`;
                this.gameBoard.rows[i].cells[j].innerText = currState[i][j];
            } else if (currState[i][j] === 0 && regex.test(this.gameBoard.rows[i].cells[j].className)) {
                this.gameBoard.rows[i].cells[j].className = "field-cell";
                this.gameBoard.rows[i].cells[j].innerText = "";
            }
        }
    }
    #addCell() {
        const coord = this.#getRandomEmptyCell();
        if (coord !== null) this.state[coord[0]][coord[1]] = Math.random() < 0.9 ? 2 : 4;
    }
    #getEmptyCells() {
        const emptyCells = [];
        for(let i = 0; i < this.state.length; i++){
            for(let j = 0; j < this.state[0].length; j++)if (this.state[i][j] === 0) emptyCells.push([
                i,
                j
            ]);
        }
        return emptyCells;
    }
    #getRandomEmptyCell() {
        const emptyCells = this.#getEmptyCells();
        if (emptyCells.length < 1) return null;
        const randomIndex = Math.floor(Math.random() * emptyCells.length);
        return emptyCells[randomIndex];
    }
    #transpose(arr) {
        return arr[0].map((_, colIndex)=>arr.map((row)=>row[colIndex]));
    }
    #moveCellsInGroup(group) {
        const mergedValues = [
            0,
            0,
            0,
            0
        ];
        for(let i = 1; i < group.length; i++){
            if (group[i] === 0) continue;
            const cellWithNumIndex = i;
            let targetCellIndex = null;
            let j = i - 1;
            while(j >= 0 && (group[j] === 0 || group[j] === group[cellWithNumIndex] && mergedValues[j] !== 1)){
                targetCellIndex = j;
                j--;
            }
            if (targetCellIndex === null) continue;
            if (group[targetCellIndex] === 0) {
                group[targetCellIndex] = group[cellWithNumIndex];
                group[cellWithNumIndex] = 0;
            } else {
                group[targetCellIndex] += group[cellWithNumIndex];
                group[cellWithNumIndex] = 0;
                mergedValues[targetCellIndex] = 1;
                this.score += group[targetCellIndex];
            }
        }
        return group;
    }
    #setStatus() {
        if (!this.#checkCanMove()) this.status = $a5fd07fa01589658$var$Game.STATUSES.lose;
        if (this.#checkWin()) this.status = $a5fd07fa01589658$var$Game.STATUSES.win;
    }
    #checkWin() {
        return this.state.some((row)=>{
            return row.some((cell)=>cell === 2048);
        });
    }
    #checkCanMove() {
        const emptyCells = this.#getEmptyCells();
        if (emptyCells.length >= 1) return true;
        const canMoveHorisontal = this.state.some((row)=>{
            const reversedRow = [
                ...row
            ];
            if (this.#canMoveInGroup(row) || this.#canMoveInGroup(reversedRow)) return true;
            return false;
        });
        const canMoveVertical = this.#transpose(this.state).some((row)=>{
            const reversedRow = [
                ...row
            ];
            if (this.#canMoveInGroup(row) || this.#canMoveInGroup(reversedRow)) return true;
            return false;
        });
        return canMoveHorisontal || canMoveVertical;
    }
    #canMoveInGroup(group) {
        return group.some((cell, index)=>{
            if (index === 0) return false;
            if (cell === 0) return false;
            if (group[index - 1] === 0) return true;
            if (group[index] === group[index - 1]) return true;
            return false;
        });
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports($09e991522ca7e64e$var$initialState, $09e991522ca7e64e$var$gameField.tBodies[0], $09e991522ca7e64e$var$scoreField);
$09e991522ca7e64e$var$button.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$button.classList.contains("start")) {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$button.classList.remove("start");
        $09e991522ca7e64e$var$button.classList.add("restart");
        $09e991522ca7e64e$var$button.innerText = "Restart";
        $09e991522ca7e64e$var$startMessage.classList.add("hidden");
    } else if ($09e991522ca7e64e$var$button.classList.contains("restart")) {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$button.classList.remove("restart");
        $09e991522ca7e64e$var$button.classList.add("start");
        $09e991522ca7e64e$var$button.innerText = "Start";
        $09e991522ca7e64e$var$startMessage.classList.remove("hidden");
        $09e991522ca7e64e$var$winMessage.classList.add("hidden");
        $09e991522ca7e64e$var$loseMessage.classList.add("hidden");
    }
    $09e991522ca7e64e$var$game.updateGameBoard();
});
$09e991522ca7e64e$var$setupInputOnce();
function $09e991522ca7e64e$var$setupInputOnce() {
    window.addEventListener("keydown", $09e991522ca7e64e$var$handleInput, {
        once: true
    });
    $09e991522ca7e64e$var$setupTouchControls();
}
function $09e991522ca7e64e$var$handleInput(e) {
    switch(e.key){
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        default:
            $09e991522ca7e64e$var$setupInputOnce();
            return;
    }
    $09e991522ca7e64e$var$updateGame();
}
function $09e991522ca7e64e$var$setupTouchControls() {
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    const threshold = 50;
    window.addEventListener("touchstart", (e)=>{
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
    }, {
        once: true
    });
    window.addEventListener("touchend", (e)=>{
        touchEndX = e.changedTouches[0].clientX;
        touchEndY = e.changedTouches[0].clientY;
        handleSwipe();
    }, {
        once: true
    });
    function handleSwipe() {
        const deltaX = touchEndX - touchStartX;
        const deltaY = touchEndY - touchStartY;
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            if (deltaX > threshold) $09e991522ca7e64e$var$game.moveRight();
            else if (deltaX < -threshold) $09e991522ca7e64e$var$game.moveLeft();
        } else {
            if (deltaY > threshold) $09e991522ca7e64e$var$game.moveDown();
            else if (deltaY < -threshold) $09e991522ca7e64e$var$game.moveUp();
        }
        $09e991522ca7e64e$var$updateGame();
    }
}
function $09e991522ca7e64e$var$updateGame() {
    $09e991522ca7e64e$var$game.updateGameBoard();
    const resultStatus = $09e991522ca7e64e$var$game.getStatus();
    if (resultStatus === $a5fd07fa01589658$exports.STATUSES.win) $09e991522ca7e64e$var$winMessage.classList.remove("hidden");
    if (resultStatus === $a5fd07fa01589658$exports.STATUSES.lose) $09e991522ca7e64e$var$loseMessage.classList.remove("hidden");
    $09e991522ca7e64e$var$setupInputOnce();
}


//# sourceMappingURL=index.eb7e8976.js.map
